import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "side-menu-field-descr min-width-0 d-flex"
}
const _hoisted_2 = { class: "text-truncate" }
const _hoisted_3 = {
  key: 0,
  class: "ml-1 flex-fill"
}
const _hoisted_4 = { class: "field-value" }
const _hoisted_5 = {
  class: "text-truncate",
  style: {"max-width":"300px"}
}
const _hoisted_6 = {
  class: "text-truncate",
  style: {"max-width":"300px"}
}
const _hoisted_7 = { class: "d-flex w-100" }
const _hoisted_8 = {
  key: 0,
  class: "side-menu-icon input-padding-top",
  style: {"margin-top":"-1px"}
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "flex-fill" }

import {computed, getCurrentInstance, inject} from 'vue';
import {NAME_FIELDS} from "~/operatorApplication/ts/data/StandartClientFields";
import FormElementFactory from "~/cabinet/vue/interface/form/elements/FormElementFactory.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import {
    FIELD_TYPE_MOBILE,
    FIELD_TYPE_TEXT,
    FIELD_TYPE_TEXTAREA,
    IFieldWithOptions
} from "~/cabinet/vue/interface/form/elements/Interfaces";
import {LINK_REGEXP} from "~/core-ui/vue/ui/CoreUiHtmlifyHelper";
import {__} from "~/ts/library/Translate";
import ElNotify from "~/core-ui/vue/ui/ElNotify";
import SideMenuCardSection from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCardSection.vue";
import {FormElementExposeInterface} from "~/cabinet/vue/interface/form/elements/useFormElement";
import {IconStyle} from "~/chat/ts/data/ISiteParams";
import {
    CLIENT_FIELD_PHONE
} from "~/operatorApplication/ts/data/StandartClientFields";
import OperatorApplicationPlatformIcon from "~/operatorApplication/vue/misc/OperatorApplicationPlatformIcon.vue";
import {
    TelephonyCallInjectionKey
} from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/fields/TelephonyCallInjectionKey";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import Dictionary from "~/ts/library/Dictionary";
import OperatorApplicationClientFieldAutoLinksOpenApiModel = OperatorApplicationApi.OperatorApplicationClientFieldAutoLinksOpenApiModel;



const __default__ = {
    name: "ClientField"
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    userdata: {},
    fieldValues: {},
    links: {},
    field: {},
    nextField: {},
    joinedFields: {},
    isSavingNow: { type: Boolean },
    showTitle: { type: Boolean },
    showIcon: { type: Boolean },
    canEdit: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["focus", "remove", "update:modelValue"], ["update:modelValue"]),
  setup(__props: any, { expose: __expose, emit: __emit }) {

let props = __props;

let model = _useModel<any>(__props, "modelValue");

let emits = __emit;

let telephonyInjection = inject(TelephonyCallInjectionKey, null);


let exposedObject: FormElementExposeInterface = {
    focus: () => {
        let input: FormElementExposeInterface = instance.$refs.input as any;
        if (input) {
            input.focus();
        }
    },
    field: props.field
};

__expose(exposedObject);

let instance = getCurrentInstance().proxy;

let fieldValue = computed(() => {
    let name = props.field.name;
    let result = typeof model.value != "undefined" ? model.value : props.fieldValues[name];
    if (typeof result == "object" && result) {
        if ([FIELD_TYPE_TEXT, FIELD_TYPE_TEXTAREA].indexOf(props.field.type) > -1) {
            result = JSON.stringify(result, null, 4);
        }
    }
    return result;
});

let hasValue = computed(() => {
    let value = props.fieldValues[props.field.name];
    if ((typeof value == "string" || Array.isArray(value)) && !value.length) {
        return false;
    }
    return value != null;
});


let isNeedDescr = computed(() => {
    return hasValue.value || typeof model.value != "undefined";
});


let isNeedToShowActions = computed(() => {
    return [FIELD_TYPE_TEXT, FIELD_TYPE_TEXTAREA, FIELD_TYPE_MOBILE].includes(props.field.type);
});

let links = computed(() => {
    let result: { url: string, descr?: string }[] = [];
    if (isNeedToShowActions.value) {
        let value = props.fieldValues[props.field.name];
        if (typeof value == "string") {
            let links = value.match(LINK_REGEXP);
            if (links && links.length) {
                for (let link of links) {
                    result.push({
                        url: link
                    })
                }
            }
        }
    }
    let fieldNames = props.joinedFields ?? [props.field.name];
    for (let name of fieldNames) {
        let linksOfField = props.links[name];
        if (linksOfField) {
            for (let link of linksOfField.links) {
                if (!result.find(item => item.url == link.url && item.descr == link.descr)) {
                    result.push({
                        descr: link.descr,
                        url: link.url
                    });
                }
            }
        }
    }
    return result;
});

function copyToClipboard() {
    navigator.clipboard.writeText(fieldValue.value).then(() => {
        ElNotify.success({
            title: __('Скопировано в буфер обмена'),
            duration: 2000,
            message: null
        });
    }, () => {
        ElNotify.error({
            title: __('Не удалось скопировать в буфер обмена'),
            duration: 2000,
            message: null
        });
    });
}

let selectedOption = computed(() => {
    let field: IFieldWithOptions = props.field as any;
    return field.options?.find(option => option.value == fieldValue.value);
})

let icon = computed(() => {
    if (props.showIcon) {
        return selectedOption.value?.icon ?? props.field.icon;
    } else {
        return null;
    }
});

let iconStyle = computed<IconStyle>(() => {
    return selectedOption.value?.iconStyle ?? (props.field.iconStyle as IconStyle);
});

let iconColor = computed(() => {
    return selectedOption.value?.iconColor;
});

let mobileInfo = computed<OperatorApplicationApi.OperatorApplicationClientMobileInfoOpenApiModel>(() => {
    if (props.field.name == CLIENT_FIELD_PHONE) {
        return props.userdata.mobileInfo;
    }
    return null;
});

let mobileIcon = computed(() => {
    return mobileInfo.value?.opsosIconUrl;
});

let mobileInfoTooltip = computed(() => {
    let data = mobileInfo.value;
    let info = [
        data?.countryDescr,
        data?.districtDescr,
        data?.opsosDescr
    ].filter(item => typeof item == "string");
    return info.length ? info.join(", ") : null;

});

async function makeTelephonyCall(auth: OperatorApplicationApi.OperatorGetParamsIntegrationAuthOpenApiModel) {
    if (telephonyInjection) {
        telephonyInjection.value.makeCall(fieldValue.value, auth);
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_collapse_transition = _resolveComponent("el-collapse-transition")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createBlock(SideMenuCardSection, {
    class: _normalizeClass({
            'operator-side-menu-field': true,
            'field-fio-part': _unref(NAME_FIELDS).includes(_unref(props).field.name),
            'next-field-fio-part': _unref(props).nextField && _unref(NAME_FIELDS).includes(_unref(props).nextField.name)
        }),
    compact: ""
  }, {
    default: _withCtx(() => [
      (_unref(props).showTitle)
        ? (_openBlock(), _createBlock(_component_el_collapse_transition, { key: 0 }, {
            default: _withCtx(() => [
              (_unref(isNeedDescr))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.field.descr), 1),
                    (__props.isSavingNow)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(MyLoader)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_unref(isNeedToShowActions))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "text-field-action",
              onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop","prevent"])),
              onMouseup: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
            }, [
              (_unref(fieldValue) && _unref(telephonyInjection) && _unref(telephonyInjection).telephonyCallAuthList.length > 0 && __props.field.type == _unref(FIELD_TYPE_MOBILE))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_unref(telephonyInjection).telephonyCallAuthList.length == 1)
                      ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          link: "",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (makeTelephonyCall(_unref(telephonyInjection).telephonyCallAuthList[0])))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(FontAwesomeIcon, { icon: "phone-volume" })
                          ]),
                          _: 1
                        })), [
                          [_directive_my_tooltip, {delay: 500, text: _unref(__)('Позвонить')}]
                        ])
                      : (_openBlock(), _createBlock(_component_el_dropdown, {
                          key: 1,
                          trigger: "click",
                          onCommand: _cache[1] || (_cache[1] = ($event: any) => (makeTelephonyCall($event)))
                        }, {
                          dropdown: _withCtx(() => [
                            _createVNode(_component_el_dropdown_menu, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(telephonyInjection).telephonyCallAuthList, (auth, i) => {
                                  return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    key: i,
                                    command: auth
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_5, [
                                        (_unref(telephonyInjection).integrationPlatformDictionary[auth.platformId])
                                          ? (_openBlock(), _createBlock(OperatorApplicationPlatformIcon, {
                                              key: 0,
                                              platform: _unref(telephonyInjection).integrationPlatformDictionary[auth.platformId],
                                              class: "mr-2"
                                            }, null, 8, ["platform"]))
                                          : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(auth.descr), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["command"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _withDirectives((_openBlock(), _createBlock(_component_el_button, { link: "" }, {
                              default: _withCtx(() => [
                                _createVNode(FontAwesomeIcon, { icon: "phone-volume" })
                              ]),
                              _: 1
                            })), [
                              [_directive_my_tooltip, {text: _unref(__)('Позвонить'), delay: 500}]
                            ])
                          ]),
                          _: 1
                        }))
                  ], 64))
                : _createCommentVNode("", true),
              (_unref(links).length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_unref(links).length  == 1)
                      ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          link: "",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(OperatorApplicationPlatform).openExternal(_unref(links)[0].url)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(FontAwesomeIcon, { icon: "external-link" })
                          ]),
                          _: 1
                        })), [
                          [_directive_my_tooltip, {text: _unref(__)('Открыть в браузере'), delay: 500}]
                        ])
                      : (_openBlock(), _createBlock(_component_el_dropdown, {
                          key: 1,
                          trigger: "click",
                          onCommand: _cache[3] || (_cache[3] = ($event: any) => (_unref(OperatorApplicationPlatform).openExternal($event)))
                        }, {
                          dropdown: _withCtx(() => [
                            _createVNode(_component_el_dropdown_menu, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(links), (link, i) => {
                                  return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    key: i,
                                    command: link.url
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_6, _toDisplayString(link.descr ? link.descr : link.url), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["command"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", null, [
                              _withDirectives((_openBlock(), _createBlock(_component_el_button, { link: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(FontAwesomeIcon, { icon: "external-link" })
                                ]),
                                _: 1
                              })), [
                                [_directive_my_tooltip, {text: _unref(__)('Открыть в браузере'), delay: 500}]
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                  ], 64))
                : _createCommentVNode("", true),
              (_unref(fieldValue))
                ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    link: "",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (copyToClipboard()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(FontAwesomeIcon, { icon: "copy" })
                    ]),
                    _: 1
                  })), [
                    [_directive_my_tooltip, {text: _unref(__)('Копировать'), delay: 500}]
                  ])
                : _createCommentVNode("", true)
            ], 32))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          (_unref(icon))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (!_unref(props).showTitle && __props.isSavingNow)
                  ? (_openBlock(), _createBlock(MyLoader, { key: 0 }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_unref(mobileIcon))
                        ? _withDirectives((_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _unref(mobileIcon),
                            class: "mobile-icon flag-icon"
                          }, null, 8, _hoisted_9)), [
                            [_directive_my_tooltip, _unref(mobileInfoTooltip)]
                          ])
                        : (_openBlock(), _createBlock(FontAwesomeIcon, {
                            key: 1,
                            class: "field-icon",
                            icon: _unref(icon),
                            "icon-style": _unref(iconStyle),
                            style: _normalizeStyle({
                                color: _unref(iconColor)
                            })
                          }, null, 8, ["icon", "icon-style", "style"]))
                    ], 64))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(FormElementFactory, {
              field: __props.field,
              class: "field-input",
              "model-value": _unref(fieldValue),
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_unref(emits)('update:modelValue', $event))),
              onFocus: _cache[8] || (_cache[8] = ($event: any) => (_unref(emits)('focus'))),
              ref: "input",
              preview: __props.isSavingNow || !__props.canEdit,
              "auto-emit-value-when-empty": false,
              "disallow-option-icon": "",
              clearable: ""
            }, null, 8, ["field", "model-value", "preview"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})